import { pad, type JourneyCommand } from "./journeyData";

export function CommandProgress({ cmds, index, onGo }: { cmds: JourneyCommand[]; index: number; onGo: (i: number) => void }) {
  return (
    <div className="mt-5" data-testid="command-progress">
      <div className="flex items-center justify-between font-condensed text-sm font-extrabold uppercase tracking-[0.14em] text-[#FFFFFF]">
        <span data-testid="command-progress-label"><span className="text-[#F5D536]">{pad(index + 1)}</span> / {pad(cmds.length)}</span>
        <span className="text-[#B8BEC8]">{cmds[index]?.stage.name}</span>
      </div>
      <div className="mt-2 h-2 w-full border-2 border-[#3A3F48] bg-[#171A1F]" role="progressbar" aria-valuemin={1} aria-valuemax={cmds.length} aria-valuenow={index + 1} aria-label="Command progress">
        <div className="h-full bg-[#F5D536] transition-[width] duration-300 motion-reduce:transition-none" style={{ width: `${((index + 1) / cmds.length) * 100}%` }} />
      </div>
      <div className="mt-3 flex flex-wrap justify-center gap-1" aria-label="Go to command">
        {cmds.map((c, i) => (
          <button key={c.code} type="button" onClick={() => onGo(i)} aria-label={`${pad(i + 1)} ${c.code}`} aria-current={i === index ? "step" : undefined}
            data-testid={`command-dot-${c.slug}`} className="flex h-6 w-6 items-center justify-center">
            <span className={`block h-2.5 w-2.5 border-2 ${i === index ? "border-[#F5D536] bg-[#F5D536]" : i < index ? "border-[#F5D536]" : "border-[#5A606B]"}`} />
          </button>
        ))}
      </div>
    </div>
  );
}
